const AVATAR_COLOR_PALETTE: Array<{ bg: string; color: string }> = [
  { bg: 'var(--ant-red-1, #FEECEB)', color: 'var(--ant-red-7, #C0392B)' },
  { bg: 'var(--ant-green-1, #E8F5E9)', color: 'var(--ant-green-7, #1B5E20)' },
  { bg: 'var(--ant-blue-1, #E3F2FD)', color: 'var(--ant-blue-7, #0D47A1)' },
  { bg: 'var(--ant-gold-1, #FFF3E0)', color: 'var(--ant-gold-7, #E65100)' },
  { bg: 'var(--ant-purple-1, #FFF0F6)', color: 'var(--ant-purple-7, #9C1E63)' },
  { bg: 'var(--ant-purple-3, #F3E5F5)', color: 'var(--ant-purple-6, #4A148C)' },
  { bg: 'var(--ant-blue-3, #E0F7FA)', color: 'var(--ant-blue-9, #006064)' },
  { bg: 'var(--ant-green-3, #F9FBE7)', color: 'var(--ant-green-8, #827717)' },
];

export const getColorTheme = (seed: string | undefined) => {
  if (!seed) return undefined;

  const HASH_PRIME = 31;
  const HASH_MOD = 2 ** 31 - 1;
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * HASH_PRIME + seed.charCodeAt(i)) % HASH_MOD;
  }

  const index = Math.abs(hash) % AVATAR_COLOR_PALETTE.length;
  return AVATAR_COLOR_PALETTE[index];
};
